import { render, staticRenderFns } from "./LineChart.vue?vue&type=template&id=712b28e6&scoped=true&"
import script from "./LineChart.vue?vue&type=script&lang=js&"
export * from "./LineChart.vue?vue&type=script&lang=js&"
import style0 from "./LineChart.vue?vue&type=style&index=0&id=712b28e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712b28e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('712b28e6')) {
      api.createRecord('712b28e6', component.options)
    } else {
      api.reload('712b28e6', component.options)
    }
    module.hot.accept("./LineChart.vue?vue&type=template&id=712b28e6&scoped=true&", function () {
      api.rerender('712b28e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/pages/analytics/LineChart.vue"
export default component.exports